import parentGetter from './ParentGetter';
import workflowGetter from './WorkflowGetter';

const getters = {
  ...parentGetter,
  ...workflowGetter,
};

export default getters;
